// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__IPWKR","table":"Table_table__ph0jW","row":"Table_row__0kE9C","col":"Table_col__LyXGZ","status":"Table_status__6d+-1"};